<template>
    <div class="tapes-tabs">
        <div v-if="isTabsInitialized">
            <v-tabs v-model="tab"
                    next-icon="mdi-arrow-right-bold-box-outline"
                    prev-icon="mdi-arrow-left-bold-box-outline"
                    show-arrows>
                <v-tabs-slider></v-tabs-slider>
                <v-tab v-for="(item, index) in items" :key="index">
                    <span>
                           {{ item.label }}
                    </span>
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item v-for="(item, index) in items" :key="index">
                    <div class="tapes-tabs__list">
                        <div class="tapes-tabs__item" v-for="(tape, id) in item.tapes" :key="id">
                            <img class="tapes-tabs__img" :src="tape.img" :alt="tape.name">
                            <div class="tapes-tabs__info">
                                <h3 class="tapes-tabs__title">{{ tape.name }}</h3>
                                <a href="javascript:void(0)" onclick="scrollOnBlock(formNew)"
                                   class="tapes-tabs__btn btn-red">Оставить заявку</a>
                            </div>
                        </div>
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </div>
    </div>
</template>

<script>
export default {
    name: "tapesTabs",
    props: {
        sects: Array | Object | String,
    },
    data() {
        return {
            tab: null,
            isTabsInitialized: false,
            // isIndustryDetail: false,
            /*items: [
                {
                    label: 'Предупреждающие',
                    tapes: [

                        {
                            img: '/upload/tapes.png',
                            name: 'Клейкая лента «Осторожно, хрупкое!»',
                            url: ''
                        },
                        {
                            img: '/upload/tapes-2.png',
                            name: 'Клейкая лента «Осторожно, стекло!»',
                            url: ''
                        },
                        {
                            img: '/upload/tapes-3.png',
                            name: 'Клейкая лента «Fragile»',
                            url: ''
                        },
                        {
                            img: '/upload/tapes-4.png',
                            name: 'Клейкая лента «Пожалуйста, аккуратно. Хрупкое. Спасибо!»',
                            url: ''
                        },
                    ]
                },
                {
                    label: 'Маркетинговые',
                    tapes: [
                        {
                            img: '/upload/tapes-4.png',
                            name: 'Клейкая лента «Осторожно, стекло!»',
                            url: ''
                        },
                        {
                            img: '/upload/tapes-2.png',
                            name: 'Клейкая лента «Fragile»',
                            url: ''
                        },
                    ]
                },
            ]*/
          items: this.sects,
        }
    },
    methods: {},
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.isTabsInitialized = true;
            }, 50);
        });


    },
}
</script>

<style scoped lang="scss">

.tapes-tabs {

  &__list {
    max-width: 1840px;
    padding-bottom: 20px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    overflow-y: auto;
  }

  &__item {
    white-space: normal;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border-radius: 32px;
    background: #f2f2f2;
    transition: all 0.3s ease;
  }

  &__info {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: space-between;
    gap: 54px;
    padding: 24px;
    width: 100%;

    @media (max-width: 1024px) {
      gap: 34px;
    }

    @media (max-width: 768px) {
      gap: 24px;
    }
  }

  &__img {
    width: 100%;
    max-height: 300px;
    object-fit: cover;
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;
  }

  &__title {
    font-family: 'MuseoSansCyrl-500';
    font-weight: 400;
    font-style: 500;
    font-size: 24px;
    line-height: 28px;
    letter-spacing: 0px;
    color: rgba(33, 36, 36, 1);
    margin: 0;
    white-space: normal !important;
    word-break: break-word !important;

    @media (max-width: 1024px) {
      font-size: 20px;
      line-height: 24px;
    }

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 20px;
    }
  }

  &__btn {
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(250, 66, 55, 1);
    background: rgba(250, 66, 55, 1);
    color: #ffffff;
    padding: 14px 24px;
    width: max-content;
    transition: all 0.2s ease;

  }

}

</style>

<style lang="scss">

.tapes-tabs {

  & .v-tabs-bar {
    height: 60px;
  }

  & .v-tabs {
    margin-bottom: 60px;
  }

  &__list {
    position: relative;

    & .v-slide-group__wrapper {
      height: 100% !important;
      max-height: 305px;
    }

    & .v-slide-group__content {
      padding: 19px 0;
    }

    .v-slide-group__prev,
    .v-slide-group__next {
      position: absolute;
      bottom: 10px;
      left: 52%;
      border: 1px solid #E6E6E6;
      border-radius: 8px;
      width: 56px;
      height: 56px;
      transition: all 0.2s ease;

      &:hover {
        border-color: #4F4D55;
      }
    }

    .v-icon.v-icon {
      font-size: 32px;
      color: #52525B;
    }

    .v-slide-group__prev, {
      left: calc(50% - 45px);

      @media (max-width: 1024px) {
        left: calc(50% - 60px);
      }
    }
  }

  .v-tab:not(.v-tab--active) {
    & svg {
      display: none;
    }
  }

  .v-ripple__container {
    display: none;
  }

  & .v-tabs-slider {
    height: 0;
  }

  .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
    display: none;

  }

  .v-tabs {
    @media (max-width: 766px) {
      max-width: 90vw;
    }
  }

  & .v-tab {
    gap: 14px;
    margin: 5px;
    border: 1px solid #E4E4E4;
    background: #FFFFFF;
    border-radius: 40px;
    padding: 12px 24px;
    height: 52px;
    width: 100%;
    min-width: max-content;

    &:before {
      background-color: transparent !important;
    }

    &:hover {
      opacity: 1 !important;
      border-color: #4F4D55;
    }

    & > span {
      font-family: 'MuseoSansCyrl-500';
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      letter-spacing: 0;
      color: #4F4D55 !important;
      text-transform: none;
    }

    &--active {
      border: 1px solid #FA4237;

      &:before {
        background-color: transparent !important;
      }

      &:hover {
        opacity: 1 !important;
        border-color: #FA4237;
      }

      & > span {
        color: #FA4237 !important;
      }
    }

  }

  .v-slide-group__content {
    gap: 8px;
  }

  .v-item-group {
    margin-top: 20px;


    .theme--light.v-card {
      background-color: transparent;
    }

  }

  .v-item-group.v-tabs-items {
    box-shadow: none !important;
  }

  .v-slide-group__wrapper {
    height: 75px;
  }

  & .v-tabs-bar,
  & .theme--light.v-tabs-items {
    background-color: transparent !important;
  }

  .v-slide-group:not(.v-slide-group--has-affixes) > .v-slide-group__prev, .v-slide-group:not(.v-slide-group--has-affixes) > .v-slide-group__next {
    display: none;
  }

  .mdi-arrow-right-bold-box-outline::before {
    content: '';
    background: url("/upload/chevron-right.svg") no-repeat;
    background-size: contain;
    width: 40px;
    height: 40px;
  }

  .mdi-arrow-left-bold-box-outline::before {
    content: '';
    background: url("/upload/chevron-right.svg") no-repeat;
    background-size: contain;
    width: 40px;
    height: 40px;
    rotate: 180deg;
  }

  .v-slide-group__next, .v-slide-group__prev {
    min-width: 33px;
  }

}


</style>